var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaturnGrayLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 30,
    viewBox: "0 0 45 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7683 4.54433C43.9682 2.32331 39.3168 1.61194 33.1075 2.31124C32.2266 2.41261 32.3406 2.6244 32.8112 3.12519C33.3778 3.72917 33.8297 4.24868 34.4138 5.04573C34.5405 5.22071 34.6612 5.33535 34.8778 5.36612C36.8327 5.63402 37.9665 5.97915 38.3514 6.98075C38.6344 7.71143 38.1565 8.94171 37.0686 10.1895C37.0324 10.2317 36.9902 10.274 36.954 10.3162C34.7191 12.7876 30.1304 15.6428 24.4201 17.6997C18.7098 19.7511 13.4538 20.5536 10.0991 20.2061C8.24671 20.0172 6.91989 19.5569 6.53494 18.5915L6.51684 18.5553C6.21032 17.7039 6.75457 16.4555 8.08923 15.0696C8.22197 14.9368 8.33118 14.7136 8.31308 14.5265C8.24791 13.6577 8.24852 12.9035 8.3161 11.9562C8.34083 11.5579 8.37161 11.0632 7.64092 11.5453C2.41812 14.9791 -0.674768 18.7646 0.125305 20.9923C0.919344 23.1892 5.48628 23.9367 11.599 23.3038C11.8102 23.2857 12.0274 23.2622 12.2447 23.232C16.1129 22.7716 20.6273 21.63 25.257 19.9635C29.8927 18.291 33.9739 16.1599 37.2466 14.0456C37.4276 13.925 37.6087 13.8049 37.7903 13.6842C42.8978 10.2806 45.5629 6.74121 44.7683 4.54433Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.1365 22.799C2.34359 23.9006 0.10337 19.9328 2.62337 17.6771C4.76955 15.7588 8.18219 16.0351 8.24256 13.6578C8.24377 13.734 8.24619 13.8114 8.24982 13.8876C8.25829 14.08 8.27039 14.2735 8.28612 14.4731C8.28733 14.4924 8.28854 14.5093 8.28975 14.5239C8.30547 14.715 8.1978 14.9327 8.06593 15.0706C6.73032 16.4542 6.19075 17.7049 6.49804 18.5528L6.51256 18.5939C6.89969 19.5554 8.22805 20.0163 10.0815 20.205C13.435 20.5448 18.694 19.7405 24.403 17.6771C30.1108 15.6148 34.7224 12.7918 36.9533 10.3171C36.992 10.2735 37.0319 10.23 37.0707 10.1865C38.1881 8.9112 38.5993 7.76024 38.3692 7.03516C40.4331 12.6763 22.2001 21.4129 11.1365 22.799Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2325 13.7649C31.5117 13.0771 32.6641 12.3591 33.6597 11.635C35.3189 10.4403 35.5362 9.51115 34.7638 7.90618C32.9115 4.11096 30.3713 2.02932 27.2518 0.84671C24.8954 -0.051256 22.1598 -0.311154 19.2974 0.439787C19.2912 0.441427 19.285 0.43504 19.2796 0.438505V0.438505C19.2769 0.440237 19.2736 0.442879 19.2705 0.443696C18.5782 0.624596 17.8798 0.87155 17.1755 1.17857C17.1695 1.18158 17.1649 1.18309 17.1604 1.1846C17.1559 1.18611 17.1514 1.18762 17.1453 1.19063C13.4044 2.83784 10.7858 6.30724 9.86866 9.69819C9.22305 12.1117 9.19891 14.4105 9.89279 16.9266C10.3936 18.7247 10.997 19.2013 12.9338 19.0806C15.9989 18.8936 19.8303 18.0428 23.7824 16.6189C25.1762 16.1121 26.5037 15.575 27.7406 15.0018C28.6155 14.6036 29.4481 14.1873 30.2325 13.7649ZM27.2879 25.6877C31.1133 24.2456 33.2915 21.3133 34.1301 19.7867C35.1016 18.0369 35.6325 16.5587 34.2508 17.2888C33.4423 17.7171 31.9882 18.4714 30.1358 19.298C30.1117 19.3101 30.0875 19.3221 30.0574 19.3342C28.7541 19.9315 27.2577 20.5651 25.6528 21.1564C21.936 22.5321 18.7019 23.2561 16.1557 23.8173C14.6291 24.1491 16.0652 24.8671 17.6701 25.5489C18.5752 25.9411 20.2103 26.4299 22.2135 26.5083C23.7401 26.5566 25.4898 26.3635 27.2879 25.6877Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M17.0371 1.19063C17.0492 1.1846 17.0552 1.1846 17.0673 1.17857C17.7732 0.870845 18.4731 0.623462 19.167 0.44245C19.173 0.436416 19.173 0.436416 19.1791 0.44245C22.0451 -0.311766 24.7844 -0.052316 27.1436 0.84671C30.263 2.02932 32.8033 4.11096 34.6556 7.90618C35.4279 9.51115 35.2107 10.4403 33.5514 11.635C32.5559 12.3591 31.4034 13.0771 30.1243 13.7649C29.1709 6.93475 24.7844 -0.836701 17.0371 1.19063Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M34.1305 19.7865C33.2918 21.313 31.1136 24.2454 27.2882 25.6875C25.4902 26.3633 23.7404 26.5564 22.2139 26.5081C27.1012 25.953 29.2794 22.5741 30.0577 19.334C30.0879 19.3219 30.112 19.3098 30.1362 19.2978C31.9885 18.4712 33.4426 17.7169 34.2512 17.2885C35.6329 16.5585 35.1019 18.0367 34.1305 19.7865Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6976 13.6548C37.5161 13.7746 37.3358 13.8955 37.1532 14.0116C37.0673 14.0673 36.9802 14.1229 36.8931 14.1797C46.0831 6.87911 43.7686 3.29482 38.7779 4.21212C35.5215 4.81071 34.9616 4.94303 32.7048 3.06308C32.631 2.98567 32.5523 2.90947 32.4737 2.83448C32.4676 2.82843 32.4616 2.82239 32.4567 2.81634C32.2293 2.51275 32.3067 2.36398 33.0012 2.28536C39.2134 1.579 43.8651 2.28173 44.6672 4.50241C45.4632 6.70131 42.8041 10.2416 37.6976 13.6548Z",
    fill: "url(#paint5_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -0.0000411994,
    y1: 21.3252,
    x2: 43.2969,
    y2: 4.01842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF2571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC92B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: -21.5945,
    y1: 27.2691,
    x2: 37.1672,
    y2: 0.854808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6E8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDA5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 21.0723,
    y1: 28.9932,
    x2: 39.8145,
    y2: 13.6986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F26F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA27FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 26.015,
    y1: 14.8109,
    x2: 24.9223,
    y2: -0.627234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9136FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E752FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 26.4527,
    y1: 32.7292,
    x2: 37.3244,
    y2: 11.8708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#215FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F258FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 39.1062,
    y1: 15.1216,
    x2: 43.7785,
    y2: 3.31662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB931"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE55A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturnGrayLogo);
export default __webpack_public_path__ + "static/media/saturn_gray_logo.4371e6983d7ed33e4f92ce5732e001e1.svg";
export { ForwardRef as ReactComponent };